import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="wechat-modal"
export default class extends Controller {
  static targets = ["modal"]

  show() {
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  hide() {
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  // Hide modal when clicking outside the modal content
  clickOutside(event) {
    if (event.target === this.modalTarget) {
      this.hide()
    }
  }

  // Hide modal when pressing Escape key
  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
  }

  handleKeydown(event) {
    if (event.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
      this.hide()
    }
  }
}
